// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2tFMO","tab":"Tabs_tab__30ouQ","tabActive":"Tabs_tabActive__3X7N3"};